
import React from 'react'
import soailogo from "../assets/images/logoSOAI_Plan de travail 1.png";
import { Container, Row, Col } from 'react-bootstrap';
import './navbar/navbar.css'
export default function DescriptionContent() {
    return (
        <section id="link">
            <Container>
                <Row className="justify-content-md-center">
                    <Col className="definition" lg={6}>
                        <h1>School of AI Algiers</h1>
                        <p>A local community of developers, students and lovers of artificial intelligence in Algeria.
                        We organize many events in the AI field.
                        One of them is Break with a researcher (professional in AI)  where we talk about a specific topic in the AI field.
</p>
                    </Col>
                    <Col className="logo-container" lg={4}><img alt="SOAI logo" className="soailogo_img" src={soailogo} /></Col>


                </Row>


            </Container>
            <Container className="event-container" >
                <Row className="justify-content-md-center">
                    <Col className="event-definition" >
                        <h1>What's AI DAY</h1>
                        <p>

                            This is our first flagship event of the year.
                            After the success of the first edition of the year
                            past, the second edition
                            is here !
                            This event consists of a state of the art
                            of what has been done in AI during the last
                            year. AI Day is full journey of a variety workshops for everyone
                             and talks in which participants get to learn about many topics in AI.
                           
                        </p>
                    </Col>


                </Row>
            </Container>
        </section>)

}
